/**
 * Retrieve the value of property on an object by it's path
 *
 * @param  {Object} obj          The object to query
 * @param  {String} path         The path of the property to get
 * @param  {mixed} defaultValue  The value returned when the property cannot be found
 *
 * @return {mixed}
 */
export function get (obj, path, defaultValue) {
  if (!(obj && path)) {
    return defaultValue;
  }

  let current = obj;
  const parts = path.split('.');

  for (let i = 0, len = parts.length; i < len; i++) {
    const part = parts[i];
    if (!current[part]) {
      return defaultValue;
    }
    current = current[part];
  }

  return current;
}
